<template>
  <div>
    <h1 class="d-flex flex-wrap justify-center text-center">
      <div :class="{
        'mr-10': $vuetify.breakpoint.smAndUp
        }" style="font-weight:normal">
        {{cursor + 1}} / {{ nbQuestions }}
      </div>
      <div :class="{
        'title-small': $vuetify.breakpoint.smAndDown
      }">
        {{ one.question }}
      </div>
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    cursor: Number,
    nbQuestions: Number,
    one: Object
  }
}
</script>

<style scoped>
.title-small {  
  font-size: 0.8em;
}
</style>